import { Dispatch, FC, SetStateAction } from "react";
import { ChatbotWidget } from "./ChatbotWidget";
import { ChatbotWindow } from "./ChatbotWindow";
import { cn } from "../../../utils";
import { ChatbotMessage } from "@ac-expo/api-types";
import { PropsWithClassName } from "../../../types/PropsWithClassName";

type ChatbotOverlayProps = {
  context: {
    showWindow: boolean;
    setShowWindow: Dispatch<SetStateAction<boolean>>;
    showWidget: boolean;
    setShowWidget: Dispatch<SetStateAction<boolean>>;
    isBotWriting: boolean;
    messages: ChatbotMessage[];
    sendMessage: (content: string) => void;
  };
};
export const ChatbotOverlay: FC<PropsWithClassName<ChatbotOverlayProps>> = ({
  className,
  context,
}) => {
  return (
    <div
      className={cn(
        "absolute bottom-4 right-4 z-[9999] flex flex-col items-end gap-4",
        className
      )}
    >
      {context.showWindow ? <ChatbotWindow {...context} /> : null}
      {context.showWidget ? (
        <ChatbotWidget setShowWindow={context.setShowWindow} />
      ) : null}
    </div>
  );
};
